import Axios from "../utils/Axios";

export const getSalaryDetails = async () => {
  const response = await Axios.get("/employee/");
  return response.data;
};

export const updateSalaryDetails = async (emp_id, data) => {
  const response = await Axios.put(`/employee/update/${emp_id}`, { data });
  return response.data;
};

export const clearLoans = async () => {
  const response = await Axios.put("/employee/update/clearloans");
  return response.data;
};

export const getTerminatedEmployees = async () => {
  const response = await Axios.get("/employee/terminated");
  return response.data;
};

export const employeeTermination = async (emp_id) => {
  const response = await Axios.put(`/employee/termination/${emp_id}`);
  return response.data;
};

export const getTemplate = async () => {
  try {
    const response = await Axios.get("/employee/update/gettemplate", {
      responseType: "blob", // for the excel  file
    });
    // Create a blob URL for the file
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);

    // Create a link element and simulate a click to trigger the download
    const a = document.createElement("a");
    a.href = url;
    a.download = "salary-bulk-template.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Optionally, revoke the blob URL after use
    window.URL.revokeObjectURL(url);
    return response.data;
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};

export const sendTemplate = async (formData) => {
  await Axios.post("/employee/update/sendtemplate", formData, {
    responseType: "blob",
  });
};
